// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tournament-phases-drop-down__btns-action {
    display: flex;    
}

/* .league-tournament-report__phases__list.end-phase {
    justify-content: space-between;
    width: 100%;
} */

.tournament-phases-drop-down__btns-action__unfinished-matches {
    position: relative;
}

.tournament-phases-drop-down__btns-action__unfinished-matches__tooltip .baloa-table-column {
    font-weight: var(--font-regular);
    color: var(--primary-dark-color);
}

.tournament-phases-drop-down__btns-action__unfinished-matches__tooltip {
    position: absolute;
    padding: var(--space-half-quarter);
    background-color: var(--white-color);
    border-radius: var(--space-half);
    border: 1px solid var(--new-gray-background-color);
    bottom: 64px;
    width: 230px;
    box-shadow: var(--shadow-card);
    display: none;
}

.tournament-phases-drop-down__btns-action__unfinished-matches__tooltip::after {
    content: "";
    position: absolute;
    width: 0;
    height: 0;
    margin-left: -15px;
    bottom: -20px;
    left: 50%;
    box-sizing: border-box;
    border: 10px solid var(--new-gray-background-color);
    border-color: transparent transparent var(--white-color) var(--white-color);
    transform-origin: 0 0;
    transform: rotate(-45deg);
    box-shadow: -1px 1px 1px 0 rgb(0 0 0 / 25%);
}

.tournament-phases-drop-down__btns-action__unfinished-matches:hover .tournament-phases-drop-down__btns-action__unfinished-matches__tooltip {
    display: block;
}

.tournament-phases-drop-down__btns-action .button {
    padding: var(--space-half) var(--space);
    font-size: calc( var(--space) + 1);
    line-height: calc( var(--space) + var(--space-quarter) );
}

.tournament-phases-drop-down__btns-action .primary-button {
    display: flex;
    gap: var(--space);
    align-items: center;
}

.tournament-phases-drop-down__btns-action .primary-button .hubicon-add_option {
    font-size: calc( var(--space) + 1);
    line-height: calc( var(--space) + var(--space-quarter) );
}

.tournament-phases-drop-down__container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
}

.tournament-phases-drop-down__container .MuiFormControl-root {
    min-width: 350px;
    margin: 16px 16px 24px 16px;
    border: 1px solid var(--new-gray-color);
    padding: var(--space-half-quarter);
    border-radius: var(--space-quarter);
}

.tournament-phases-drop-down__container .MuiInput-underline:before,
.tournament-phases-drop-down__container .MuiInput-underline:hover:not(.Mui-disabled):before {
    border-bottom: none;
}

.tournament-phases-drop-down__btns-action .primary-button {
    margin-left: var(--space-half-quarter);
}

.tournament-phases-drop-down__container .MuiInputBase-root {
    font-family: var(--secondary-font);
    font-weight: var(--font-medium);
    font-size: calc(var(--space) + var(--space-eighth) + 1px);
    line-height: calc(var(--space) + var(--space-quarter) + var(--space-eighth));
}`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/tournament-phases-dropDown/TournamentPhasesDropDown.styles.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB;;AAEA;;;GAGG;;AAEH;IACI,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;IAChC,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,kCAAkC;IAClC,oCAAoC;IACpC,gCAAgC;IAChC,kDAAkD;IAClD,YAAY;IACZ,YAAY;IACZ,8BAA8B;IAC9B,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,kBAAkB;IAClB,aAAa;IACb,SAAS;IACT,sBAAsB;IACtB,mDAAmD;IACnD,2EAA2E;IAC3E,qBAAqB;IACrB,yBAAyB;IACzB,2CAA2C;AAC/C;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,uCAAuC;IACvC,kCAAkC;IAClC,wDAAwD;AAC5D;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,kCAAkC;IAClC,wDAAwD;AAC5D;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,2BAA2B;IAC3B,uCAAuC;IACvC,kCAAkC;IAClC,mCAAmC;AACvC;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,kCAAkC;IAClC,+BAA+B;IAC/B,yDAAyD;IACzD,4EAA4E;AAChF","sourcesContent":[".tournament-phases-drop-down__btns-action {\n    display: flex;    \n}\n\n/* .league-tournament-report__phases__list.end-phase {\n    justify-content: space-between;\n    width: 100%;\n} */\n\n.tournament-phases-drop-down__btns-action__unfinished-matches {\n    position: relative;\n}\n\n.tournament-phases-drop-down__btns-action__unfinished-matches__tooltip .baloa-table-column {\n    font-weight: var(--font-regular);\n    color: var(--primary-dark-color);\n}\n\n.tournament-phases-drop-down__btns-action__unfinished-matches__tooltip {\n    position: absolute;\n    padding: var(--space-half-quarter);\n    background-color: var(--white-color);\n    border-radius: var(--space-half);\n    border: 1px solid var(--new-gray-background-color);\n    bottom: 64px;\n    width: 230px;\n    box-shadow: var(--shadow-card);\n    display: none;\n}\n\n.tournament-phases-drop-down__btns-action__unfinished-matches__tooltip::after {\n    content: \"\";\n    position: absolute;\n    width: 0;\n    height: 0;\n    margin-left: -15px;\n    bottom: -20px;\n    left: 50%;\n    box-sizing: border-box;\n    border: 10px solid var(--new-gray-background-color);\n    border-color: transparent transparent var(--white-color) var(--white-color);\n    transform-origin: 0 0;\n    transform: rotate(-45deg);\n    box-shadow: -1px 1px 1px 0 rgb(0 0 0 / 25%);\n}\n\n.tournament-phases-drop-down__btns-action__unfinished-matches:hover .tournament-phases-drop-down__btns-action__unfinished-matches__tooltip {\n    display: block;\n}\n\n.tournament-phases-drop-down__btns-action .button {\n    padding: var(--space-half) var(--space);\n    font-size: calc( var(--space) + 1);\n    line-height: calc( var(--space) + var(--space-quarter) );\n}\n\n.tournament-phases-drop-down__btns-action .primary-button {\n    display: flex;\n    gap: var(--space);\n    align-items: center;\n}\n\n.tournament-phases-drop-down__btns-action .primary-button .hubicon-add_option {\n    font-size: calc( var(--space) + 1);\n    line-height: calc( var(--space) + var(--space-quarter) );\n}\n\n.tournament-phases-drop-down__container {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n}\n\n.tournament-phases-drop-down__container .MuiFormControl-root {\n    min-width: 350px;\n    margin: 16px 16px 24px 16px;\n    border: 1px solid var(--new-gray-color);\n    padding: var(--space-half-quarter);\n    border-radius: var(--space-quarter);\n}\n\n.tournament-phases-drop-down__container .MuiInput-underline:before,\n.tournament-phases-drop-down__container .MuiInput-underline:hover:not(.Mui-disabled):before {\n    border-bottom: none;\n}\n\n.tournament-phases-drop-down__btns-action .primary-button {\n    margin-left: var(--space-half-quarter);\n}\n\n.tournament-phases-drop-down__container .MuiInputBase-root {\n    font-family: var(--secondary-font);\n    font-weight: var(--font-medium);\n    font-size: calc(var(--space) + var(--space-eighth) + 1px);\n    line-height: calc(var(--space) + var(--space-quarter) + var(--space-eighth));\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
